import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './style.scss';

const Backdrop = ({ children, className = '', onClick, zIndex }) => (
    <div aria-hidden="true" className={classnames('backdrop', className)} onClick={onClick} style={{ zIndex }}>
        {children}
    </div>
);

Backdrop.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    zIndex: PropTypes.number,
};

export default Backdrop;
